import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { CostDatabaseData } from "@ServerTypes/costDatabase/costDatabase.schema";

const costDatabaseSlice = createSlice({
  name: "costDatabase",
  initialState: {} as CostDatabaseData,
  reducers: {
    setCostDatabase: (_state: CostDatabaseData, action: PayloadAction<CostDatabaseData | undefined>) =>
      action.payload ?? {},
  },
});

// `setCostDatabase` is intentionally exported raw (NOT wrapped with `Exact<>`).
// The consumer in actions/estimation.ts dispatches `response.data.result[0]` from
// a backend response that carries extra fields not declared on `CostDatabaseData`
// (e.g., `costDBversionId`, `versionNumber`, `currency`, `createdBy`, `createdDate`).
// Wrapping would break that valid call site.
export const { setCostDatabase } = costDatabaseSlice.actions;

export const costDatabase = costDatabaseSlice.reducer;
